import { Link } from 'react-router-dom';
import { useWalletConnectStore } from '@/stores/walletConnect';
import { useMultisigStore } from '@/stores/multisig';

export default function TransactionsList() {
  const pending = useWalletConnectStore((s) => s.pending);
  const history = useWalletConnectStore((s) => s.history);
  const activePda = useMultisigStore((s) => s.activePda);

  const shortActive = activePda
    ? `${activePda.slice(0, 6)}…${activePda.slice(-6)}`
    : '';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl font-semibold">Transactions</h1>
        <p className="text-sm text-ink-300 mt-1">
          Pending and completed vault transactions for {shortActive}
        </p>
      </div>

      <section>
        <h2 className="text-sm font-semibold text-ink-200 mb-2">
          Pending requests ({pending.length})
        </h2>
        {pending.length === 0 ? (
          <div className="rounded-xl border border-ink-800 bg-ink-900/40 px-5 py-6 text-sm text-ink-400">
            No pending dApp requests.
          </div>
        ) : (
          <ul className="space-y-2">
            {pending.map((r) => (
              <li
                key={r.id}
                className="rounded-xl border border-ink-800 bg-ink-900/40 p-4 flex items-center justify-between"
              >
                <div>
                  <div className="font-medium text-ink-100">{r.method}</div>
                  <div className="text-xs text-ink-400">
                    {r.origin ?? 'unknown origin'}
                  </div>
                  <div className="text-[11px] text-ink-500 mt-1">
                    received {new Date(r.receivedAt).toLocaleTimeString()}
                  </div>
                </div>
                <Link
                  to={`/app/transactions/${r.id}`}
                  className="rounded-lg bg-avo-500 px-3 py-1.5 text-xs font-medium text-ink-950 hover:bg-avo-400 transition-colors"
                >
                  Review
                </Link>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section>
        <h2 className="text-sm font-semibold text-ink-200 mb-2">History</h2>
        {history.length === 0 ? (
          <div className="rounded-xl border border-ink-800 bg-ink-900/40 px-5 py-6 text-sm text-ink-400">
            No transaction history yet.
          </div>
        ) : (
          <ul className="space-y-2">
            {history.map((r) => (
              <li
                key={r.id}
                className="rounded-xl border border-ink-800 bg-ink-900/40 p-4 flex items-center justify-between text-sm"
              >
                <div>
                  <div className="font-medium text-ink-100">{r.method}</div>
                  <div className="text-xs text-ink-400">
                    {r.origin ?? 'unknown origin'}
                  </div>
                </div>
                <span
                  className={[
                    'rounded-full px-2 py-0.5 text-[11px] uppercase tracking-wider',
                    r.status === 'done'
                      ? 'bg-avo-500/15 text-avo-300'
                      : r.status === 'rejected'
                        ? 'bg-ink-800 text-ink-400'
                        : 'bg-red-500/15 text-red-300',
                  ].join(' ')}
                >
                  {r.status}
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
